// ADMIN DASHBOARD WITH ALL MANAGERS
// Save as src/adminwork/AdminDashboard.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BreakBulkManager from './BreakBulkManager';
import PCTCManager from './PCTCManager';
import PCTC2Manager from './PCTC2Manager';
import IntraAsiaManager from './IntraAsiaManager';
import BayOfBengalManager from './BayOfBengalManager';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const adminUsername = sessionStorage.getItem('adminUsername') || 'admin';

  // Active tab state
  const [activeTab, setActiveTab] = useState('dashboard');

  // Check if user is logged in
  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin');
    if (isAdmin !== 'true') {
      navigate('/login');
    }
  }, [navigate]);

  // Handle logout
  const handleLogout = () => {
    sessionStorage.removeItem('isAdmin');
    sessionStorage.removeItem('adminUsername');
    navigate('/login');
  };

  // Dashboard welcome content
  const DashboardContent = () => (
    <div className="dashboard-welcome">
      <h2>Welcome to Admin Panel</h2>
      <p>You have successfully logged in to the admin dashboard.</p>
      <p>From here you can manage your application.</p>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Break Bulk Manager</h3>
          <p>Manage your break bulk vessels data.</p>
          <button
            className="card-btn"
            onClick={() => setActiveTab('breakbulk')}
          >
            Go to Break Bulk Manager
          </button>
        </div>

        <div className="dashboard-card">
          <h3>PCTC Manager</h3>
          <p>Manage Pure Car and Truck Carrier vessels data.</p>
          <button
            className="card-btn"
            onClick={() => setActiveTab('pctc')}
          >
            Go to PCTC Manager
          </button>
        </div>

        <div className="dashboard-card">
          <h3>PCTC2 Manager</h3>
          <p>Manage updated Pure Car and Truck Carrier vessels data.</p>
          <button
            className="card-btn"
            onClick={() => setActiveTab('pctc2')}
          >
            Go to PCTC2 Manager
          </button>
        </div>

        <div className="dashboard-card">
          <h3>Intra-Asia Schedule</h3>
          <p>Manage Intra-Asia sailing schedules and routes.</p>
          <button
            className="card-btn"
            onClick={() => setActiveTab('intraasia')}
          >
            Go to Intra-Asia Manager
          </button>
        </div>

        <div className="dashboard-card">
          <h3>Bay of Bengal Schedule</h3>
          <p>Manage Bay of Bengal sailing schedules and routes.</p>
          <button
            className="card-btn"
            onClick={() => setActiveTab('bayofbengal')}
          >
            Go to Bay of Bengal Manager
          </button>
        </div>
      </div>
    </div>
  );

  // Render content based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case 'breakbulk':
        return <BreakBulkManager />;
      case 'pctc':
        return <PCTCManager />;
      case 'pctc2':
        return <PCTC2Manager />;
      case 'intraasia':
        return <IntraAsiaManager />;
      case 'bayofbengal':
        return <BayOfBengalManager />;
      default: // dashboard
        return <DashboardContent />;
    }
  };

  return (
    <div className="admin-dashboard">
      <header className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <div className="user-info">
          <span>Welcome, {adminUsername}</span>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </header>

      <div className="dashboard-content">
        <aside className="sidebar">
          <nav className="sidebar-nav">
            <button
              className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              Dashboard
            </button>
            <button
              className={`nav-item ${activeTab === 'breakbulk' ? 'active' : ''}`}
              onClick={() => setActiveTab('breakbulk')}
            >
              Break Bulk Manager
            </button>
            <button
              className={`nav-item ${activeTab === 'pctc' ? 'active' : ''}`}
              onClick={() => setActiveTab('pctc')}
            >
              PCTC Manager
            </button>
            <button
              className={`nav-item ${activeTab === 'pctc2' ? 'active' : ''}`}
              onClick={() => setActiveTab('pctc2')}
            >
              PCTC2 Manager
            </button>
            <button
              className={`nav-item ${activeTab === 'intraasia' ? 'active' : ''}`}
              onClick={() => setActiveTab('intraasia')}
            >
              Intra-Asia Schedule
            </button>
            <button
              className={`nav-item ${activeTab === 'bayofbengal' ? 'active' : ''}`}
              onClick={() => setActiveTab('bayofbengal')}
            >
              Bay of Bengal Schedule
            </button>
          </nav>
        </aside>

        <main className="main-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;